/**
 * @Author: Ygm
 * @Date: 2024-08-05 13:42:47
 * @LastEditors: Ygm
 * @LastEditTime: 2026-03-27 10:14:31
 * @Description: 公共接口
 */
import { request } from '@/utils/request'

const base_suffix = '/api/base'

/**
 * @description 获取用户信息
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getUserInfoToIdReq = (data = {}) => {
  const url = `${base_suffix}/user/get`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 本人作为工作组管理员的工作组
 * @param {*} data 入参
 * @returns
 */
const getWorkgroupAdmin = (data = {}) => {
  const url = '/api/orgproject/workGroup/manageListAsWorkGroupAdmin'
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取工作组有指定权限的成员
 * @param {*} data 入参
 * @returns
 */
const getWorkgroupUsers = (data = {}) => {
  const url = '/api/base/project/getUserByWorkgroupSpy'
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 本人作为工作组管理员的项目计划
 * @param {*} params
 * @returns
 */
const getListAsWorkGroupAdmin = params => {
  const url = '/api/orgproject/project/listAsWorkGroupAdmin'
  return new Promise((resolve, reject) => {
    request(url, params, resolve, reject)
  })
}

/**
 * @description 获取用户菜单下按钮权限
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getButtonSpyList = (data = {}) => {
  const url = `${base_suffix}/role/getButtonSpyList`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取公文详情
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getNotifyDetails = (data = {}) => {
  const url = `/api/noticetask/notify/details`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取工作组详情
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getWorkGroupDetails = (data = {}) => {
  const url = `/api/noticetask/common/workGroup/detail`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取录入人员
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getEntryUsers = (data = {}) => {
  const url = `/api/infoInput/getEntryUsers`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取人员权限相关的工作组(包含被删除的工作组)
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getIncludeDelWorkgroupByUserSpy = (data = {}) => {
  const url = `/api/base/project/getIncludeDelWorkgroupByUserSpy`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取系统服务器时间
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getSystemTime = (data = {}) => {
  const url = '/api/base/im/getSystemtime'
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 根据工作组Id集合和权限码获取工作组状态
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getWorkgroupStatus = (data = {}) => {
  const url = '/api/orgproject/workGroup/workgroupDetials'
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

export {
  getUserInfoToIdReq,
  getWorkgroupAdmin,
  getWorkgroupUsers,
  getListAsWorkGroupAdmin,
  getButtonSpyList,
  getNotifyDetails,
  getWorkGroupDetails,
  getEntryUsers,
  getIncludeDelWorkgroupByUserSpy,
  getSystemTime,
  getWorkgroupStatus
}



// WEBPACK FOOTER //
// ./src/apis/public/index.js